import { ActionButton } from '@/common/buttons/ActionButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback } from 'react';

export const DirSaleLineList = ({ dirSaleObj: dirSale }) => {
  const augRowsReq = useCallback((rowsReq) => {
    if (!dirSale) return;

    rowsReq.expr = ExprUtils.and(
      rowsReq.expr,
      ExprUtils.whereParams('dirSaleId', dirSale.id, 'invPeriodId', dirSale.invPeriodId),
    );
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  const augFieldDefs = (fieldToFieldDefs) => {
    fieldToFieldDefs.valStatus.precedence = 200;
    fieldToFieldDefs.valRes = {
      field: 'valRes',
      displayName: 'Validations',
      cellRenderer: 'valResCellRenderer',
      cellRendererParams: { entity: 'DIR_SALE_LINE' },
      minWidth: 400,
      precedence: 300,
      sortable: false,
    };
  };

  const data = {
    title: 'Direct Sales Validation',
    entity: 'DIR_SALE_LINE',
    pluginCode: 'DIR_SALE_LINE_SPARK_VAL_ACTION_PLUGIN',
  };
  const augButtons = (buttons) => {
    buttons.push(<ActionButton data={data} toolTip="Multi Validation" icon={fas.faShieldCheck} />);
  };

  return (
    <EntityList
      entity="DIR_SALE_LINE"
      disableAutoRefresh
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augButtons={augButtons}
      augFieldDefs={augFieldDefs}
    />
  );
};
